(function(){
    $('.qw-section-4-reviews').slick({
        dots: true,
        arrows: true,
        centerMode: true,
        centerPadding: '20%',
        infinite: true,
        prevArrow: `<button type="button" class="slick-prev">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="84" height="84" viewBox="0 0 84 84">
        <defs>
            <filter id="Ellipse_133" x="0" y="0" width="84" height="84" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="8" result="blur"/>
            <feFlood flood-opacity="0.161"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g id="Group_6106" data-name="Group 6106" transform="translate(-199 -2430.715)">
            <g transform="matrix(1, 0, 0, 1, 199, 2430.71)" filter="url(#Ellipse_133)">
            <g id="Ellipse_133-2" data-name="Ellipse 133" transform="translate(24 21)" fill="#fff" stroke="#163c22" stroke-width="1">
                <circle cx="18" cy="18" r="18" stroke="none"/>
                <circle cx="18" cy="18" r="17.5" fill="none"/>
            </g>
            </g>
            <path id="Path_11504" data-name="Path 11504" d="M11421.18,10406.889l-6.152,6.152,6.152,6.152" transform="translate(-11177.18 -7943.326)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        </g>
        </svg>  
        </button>
        `,
        nextArrow: `<button type="button" class="slick-next">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="84" height="84" viewBox="0 0 84 84">
        <defs>
            <filter id="Ellipse_134" x="0" y="0" width="84" height="84" filterUnits="userSpaceOnUse">
            <feOffset dy="3" input="SourceAlpha"/>
            <feGaussianBlur stdDeviation="8" result="blur"/>
            <feFlood flood-opacity="0.161"/>
            <feComposite operator="in" in2="blur"/>
            <feComposite in="SourceGraphic"/>
            </filter>
        </defs>
        <g id="Group_6107" data-name="Group 6107" transform="translate(-245 -2430.715)">
            <g transform="matrix(1, 0, 0, 1, 245, 2430.71)" filter="url(#Ellipse_134)">
            <g id="Ellipse_134-2" data-name="Ellipse 134" transform="translate(24 21)" fill="#fff" stroke="#163c22" stroke-width="1">
                <circle cx="18" cy="18" r="18" stroke="none"/>
                <circle cx="18" cy="18" r="17.5" fill="none"/>
            </g>
            </g>
            <path id="Path_11505" data-name="Path 11505" d="M11415.027,10406.889l6.152,6.152-6.152,6.152" transform="translate(-11131.027 -7943.326)" fill="none" stroke="#163c22" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        </g>
        </svg>
        </button>
        `,
        slidesToShow: 1,
        speed: 300,
        slidesToScroll: 1,
        appendArrows: $('.qw-section-4-reviews-arrows'),
        appendDots: $('.qw-section-4-reviews-dots'),
        responsive: [
            {
              breakpoint: 1600,
              settings: {
                centerPadding: '10%'
              }
            }
          ]
    });
})();